import { QueryClient } from '@tanstack/react-query';
import { isApiError } from './errors';

/** Server-state cache. Client errors (4xx) are not retried; network/5xx retry once. */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          if (isApiError(error) && error.status >= 400 && error.status < 500)
            return false;
          return failureCount < 1;
        },
      },
      mutations: { retry: false },
    },
  });
}
